<!-- <h1>Welcome Page</h1> -->
<div id='over' class='container'>

    <img src="../../../assets/willkommen.gif">
</div>


// WEBPACK FOOTER //
// ./src/app/welcome-page/welcome-page.html